import blacklistApi from './controller/blacklist';
import businessApi from './controller/business';
import clientApi from './controller/client';
import depositApi from './controller/deposit';
import docutaxClientApi from './controller/docutaxClient';
import docutaxNotificationSettingApi from './controller/docutaxNotificationSetting';
import docutaxRequestsApi from './controller/docutaxRequests';
import docutaxSubmissionsApi from './controller/docutaxSubmissions';
import ebEnrollmentApi from './controller/ebEnrollment';
import ebOptoutApi from './controller/ebOptout';
import ebQualificationApi from './controller/ebQualification';
import lookupApi from './controller/lookup';
import marriedToApi from './controller/marriedTo';
import officeApi from './controller/office';
import paystubApi from './controller/paystub';
import referralApi from './controller/referral';
import reportApi from './controller/report';
import resourceApi from './controller/resource';
import transactionApi from './controller/transaction';
import userApi from './controller/user';

export class Api {
  constructor() {
    this.blacklist = blacklistApi;
    this.business = businessApi;
    this.client = clientApi;
    this.deposit = depositApi;
    this.docutaxClient = docutaxClientApi;
    this.docutaxNotificationSetting = docutaxNotificationSettingApi;
    this.docutaxRequests = docutaxRequestsApi;
    this.docutaxSubmissions = docutaxSubmissionsApi;
    this.ebEnrollment = ebEnrollmentApi;
    this.ebOptout = ebOptoutApi;
    this.ebQualification = ebQualificationApi;
    this.lookup = lookupApi;
    this.marriedTo = marriedToApi;
    this.office = officeApi;
    this.paystub = paystubApi;
    this.referral = referralApi;
    this.report = reportApi;
    this.resource = resourceApi;
    this.transaction = transactionApi;
    this.user = userApi;
  }
}

export default new Api();
